<template>
  <div v-if="mapSrc" class="dep-mini-map" v-loading="loading">
    <div class="dep-mini-map__map-container">
      <div @click="showFullMap" v-if="!loading" class="dep-mini-map__expand-button">
        <img src="static/img/icon_map-expand.svg" :alt="$t('labels.expand')">
        {{ $t('labels.expand') }}
      </div>
      <img @load="loading = false" class="dep-mini-map__map-image" :src="mapSrc" :alt="$t('labels.map')" style="border: 0;"/>
    </div>
  </div>
</template>
<script>

  export default {
    props: [
      'geodata'
    ],
    data () {
      return {
        loading: true,
        data: this.geodata,
        mapSrc: ''
      }
    },
    methods: {
      showFullMap () {
        this.$emit('showFullMap')
      },
      getMapSrc () {
        if (this.data) {
          let coords = this.data.slice().reverse()
          this.mapSrc = 'https://static-maps.yandex.ru/1.x/?z=17&size=500,450&l=map&pt=' + coords + ',comma&ll=' + coords + ''
        }
      }
    },
    mounted () {
      this.getMapSrc()
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.dep-mini-map {
  min-height: 225px;
  margin-bottom: -15px;
  text-align: center;

  &__map-container {
    position: relative;
  }

  &__map-image {
    width: 100%;
  }

  &__expand-button {
    position: absolute;
    right: 10px;
    top: 20px;
    padding: 5px 10px;
    background: #fff;
    border-radius: $global-radius;
    font-size: 10px;
    color: #808080;
    cursor: pointer;

    img {
      margin-right: 5px;
    }
  }
}
</style>